import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { buildCountryFilterOptions } from "../constants/countryGroups";

/** Option label -> country values the backend matches on, from cached ref data. */
export const useCountryGroupMembers = (): Record<string, string[]> => {
  const { refData } = useSelector((state: RootState) => state.filter);
  return useMemo(
    () => buildCountryFilterOptions(refData?.["ref_country"]).members,
    [refData],
  );
};
